import { createFileRoute } from '@tanstack/react-router'
import { AppHeader } from '@/shared/components/layout/AppHeader'
import { SobreviventeSettingsPage } from '@/features/sobrevivente/components/SobreviventeSettingsPage'

export const Route = createFileRoute('/_authenticated/sobrevivente/$gameId/settings')({
  component: SobreviventeSettings,
})

function SobreviventeSettings() {
  const { gameId } = Route.useParams()
  return (
    <>
      <AppHeader title="Configurações do jogo" />
      <SobreviventeSettingsPage gameId={gameId} />
    </>
  )
}
